import React, { Component } from "react";

import UserRecommendationLine from "./user_recommendation_line";
import UserRecommendationComment from "./user_recommendation_comment";
import VideoPlayer from "../video_player";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQuestion, faTrash } from "@fortawesome/free-solid-svg-icons";

import DeleteView from "../view/delete";

import { deleteRecommendation } from "../../helper/recommendation_helper";
import { renderErrorMessage } from "../../helper/user_helper";
import Loader from "../loader";

import LocalizedStrings from "react-localization";
import en from "../../localization/localization-en.json";

let strings = new LocalizedStrings({ en });

class FullPageRecommendation extends Component {
  state = { deleting: false, errors: "", loaded: true };

  componentWillUnmount() {
    if (this.deleteRecommendationCall) {
      this.deleteRecommendationCall.cancel();
    }
  }

  render() {
    if (!this.state.loaded) {
      return <Loader loaded={false} />;
    }
    return (
      <div
        id={"reco" + this.props.recommendation.id}
        className="recommendation_full_page max_width_500"
      >
        <div className="center user_recommendation user_recommendation_top">
          <UserRecommendationLine
            recommendation={this.props.recommendation}
            showFullPageComments={this.props.showFullPageComments}
            featured={this.props.featured}
            question={this.props.recommendation.question}
          />
        </div>
        <div className="recommendation ">
          {this.renderMedia()}

          {/* <div className="shadow_image" /> */}

          {/* <div className="gradient" /> */}
          {this.renderDelete()}
          {/* <div className="gradient_top" /> */}
        </div>

        <div className="center user_recommendation">
          <UserRecommendationComment
            recommendation={this.props.recommendation}
            showFullPageComments={this.props.showFullPageComments}
          />
        </div>
        {this.renderRemoveRecommendation()}
        <div style={{ paddingBottom: "55px" }} />
      </div>
    );
  }

  renderMedia() {
    if (this.props.recommendation.recommendation_type === "image") {
      return (
        <img
          alt=""
          className="recommendation_full_page_img content-fit"
          src={this.props.recommendation.image_url_original}
        />
      );
    }
    if (this.props.recommendation.recommendation_type === "video") {
      const videoJsOptions = {
        autoplay: true,
        controls: true,
        muted: false,
        loop: true,
        playsInline: false,
        width: window.width,
        sources: [
          // {
          //   src: this.props.recommendation.video_url_mp4,
          //   type: "video/mp4"
          // },
          {
            src: this.props.recommendation.video_url_original
          }
        ]
      };
      if (this.props.index === this.props.pageIndex) {
        return (
          <VideoPlayer
            {...videoJsOptions}
            height={this.props.windowHeight}
            recommendation={this.props.recommendation}
          />
        );
      }
      return (
        <img
          alt=""
          className="recommendation_full_page_img content-fit"
          src={this.props.recommendation.video_url_image}
        />
      );
    }
    return <div />;
  }

  renderQuestion() {
    if (this.props.recommendation.question) {
      return (
        <div className="question_icon">
          <FontAwesomeIcon className="question_icon" icon={faQuestion} />
        </div>
      );
    }
    return <div />;
  }

  renderDelete() {
    if (
      this.props.can_delete === true &&
      this.props.recommendation.can_delete === true
    ) {
      return (
        <div className="delete_icon" onClick={this.removeRecommendationClick}>
          <FontAwesomeIcon className="delete_icon" icon={faTrash} />
        </div>
      );
    }
    return <div />;
  }

  renderRemoveRecommendation() {
    if (
      this.props.can_delete === true &&
      this.props.recommendation.can_delete === true
    ) {
      return (
        <div className="center pt-2">
          {this.renderDeleteRecommendation()}
          {renderErrorMessage(this.state.errors)}
        </div>
      );
    }
    return <div />;
  }

  removeRecommendationClick = e => {
    const deleting = !this.state.deleting;
    this.setState({ deleting });
  };

  removeRecommendation = e => {
    const self = this;
    this.setState({
      loaded: false
    });

    this.deleteRecommendationCall = deleteRecommendation(
      this.props.recommendation.id
    );
    this.deleteRecommendationCall.promise
      .then(answer => {
        self.props.returnToProfilePage();
      })
      .catch(errors_ => {
        const loaded = errors_.loaded;
        const errors = errors_.errors;
        self.setState({
          loaded,
          errors
        });
      });
  };

  renderDeleteRecommendation() {
    if (this.state.deleting) {
      return (
        <DeleteView
          message={strings.delete_recommendations}
          delete={this.removeRecommendation}
          cancel={this.removeRecommendationClick}
        />
      );
    }
    return <div />;
  }
}

export default FullPageRecommendation;



// WEBPACK FOOTER //
// ./src/components/recommendation/full_page_recommendation.jsx